import styled from "styled-components";
import {PureButton} from "components";

export const TableWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const BaseTable = styled.div`
	width: 100%;
	display: grid;
	box-shadow: 0 0.1px 0.3px rgba(28, 28, 30, 0.1), 0 1px 2px rgba(28, 28, 30, 0.2);
	border-radius: 4px 4px 0 0;
	background: ${({theme}) => theme.background.primary};
	grid-template-rows: auto;
	overflow: auto;
	max-height: 600px;
`;

export const TableItem = styled.div`
	min-height: 48px;
	padding: 10px 12px;
	font-family: "Hind", sans-serif;
	font-weight: 500;
	font-size: 14px;
	line-height: 120%;
	color: ${({theme}) => theme.color.tertiary};
	background: #545456;

	&.first-column {
		padding: 10px 12px 10px 20px;
	}

	&.last-column {
		padding: 10px 20px 10px 12px;
	}

	&.flex-end {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		text-align: center;
	}

	&.flex-start {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		text-align: center;
	}

	&.center {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	&.divider {
		position: relative;

		&:after {
			content: "";
			position: absolute;
			width: 1px;
			right: 0;
			height: 28px;
			background: #cccccc;
		}
	}

	&.sticky {
		background: #a408a4;
		position: sticky;
		top: 0;
		z-index: 1;
		color: ${({theme}) => theme.color.tertiary};
	}

	&.pink {
		background: rgba(197, 26, 32, 0.05);
	}
`;

export const TableHead = styled(TableItem)`
	color: ${({theme}) => theme.color.primary};
	background: ${({theme}) => theme.background.secondary};
	font-weight: 700;

	&.first-column {
		border-top-left-radius: 4px;
	}

	&.last-column {
		border-top-right-radius: 4px;
	}

	&.divider:after {
		background: ${({theme}) => theme.color.primary};
	}
`;

export const TableLoadMoreButton = styled(PureButton)`
	font-family: "Hind", sans-serif;
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	letter-spacing: 0.02em;
	color: ${({theme}) => theme.color.secondary};
	padding: 20px;
	background: ${({theme}) => theme.background.primary};
	border-radius: 0px 0px 4px 4px;
	border-top: 1px solid #cccccc;
`;

export const TablePreloaderWrapper = styled.div`
	width: 100%;
	padding: 20px;
`;
